export const SUGGESTED_FOR_YOU_MAX_ITEMS = 12;
export const SUGGESTED_FOR_YOU_LIMIT = 24;
